import { render, staticRenderFns } from "./MaterialManagementList.vue?vue&type=template&id=6c5ccd2c&scoped=true&"
import script from "./MaterialManagementList.vue?vue&type=script&lang=js&"
export * from "./MaterialManagementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5ccd2c",
  null
  
)

export default component.exports